import { render, staticRenderFns } from "./SellerPrice.vue?vue&type=template&id=460851fa&scoped=true&"
import script from "./SellerPrice.vue?vue&type=script&lang=js&"
export * from "./SellerPrice.vue?vue&type=script&lang=js&"
import style0 from "./SellerPrice.vue?vue&type=style&index=0&id=460851fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460851fa",
  null
  
)

export default component.exports